import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './Redux/Reducers/index';
import rootSagas from './Redux/Sagas/rootSaga';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
const sagaMiddleware = createSagaMiddleware();
const browserWindow = window;

const persistConfig = {
  key: 'persist-key',
  storage,
};

export const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [sagaMiddleware],
  devTools:
    browserWindow.__REDUX_DEVTOOLS_EXTENSION__ &&
    browserWindow.__REDUX_DEVTOOLS_EXTENSION__(),
});
export const persistedStore = persistStore(store);

sagaMiddleware.run(rootSagas);

export default store;
